import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.darkTaupe,
  fontColor: colors.metal,
  textColorDark: colors.metal,
  textColorLight: colors.white
};
export default promoBanner;